import { render } from "./ResourceTree.vue?vue&type=template&id=042f7be2"
import script from "./ResourceTree.vue?vue&type=script&lang=js"
export * from "./ResourceTree.vue?vue&type=script&lang=js"

import "./ResourceTree.vue?vue&type=style&index=0&id=042f7be2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__